import React, { useState, useEffect } from 'react'
import { useMap } from 'react-leaflet';

export default function InitialPositionButton(props) {
  const map = useMap();
  const flyToZoom = props.flyToZoom ? props.flyToZoom : 6;

  return (
    <>
      <div className='leaflet-top leaflet-right' style={{ marginTop: 220, zIndex: -1 }} >
        <div className="leaflet-bar leaflet-control">
          <a id='buttonFly' className="zmdi zmdi-my-location leaflet-bar-part" href='javascript:void(0)' title="Initial Position" onClick={() => {
            map.flyTo(props.flyToPosition, flyToZoom);
          }}></a>
        </div>
      </div>
    </>
  );
}
